module.exports = __webpack_public_path__ + "4891f0a0f44ac4543b62a86c452ea5f6.svg";